import { Btn, Card, Eyebrow, Rings, Section } from '@ui/library';

export interface ContactCTACopy {
  eyebrow: string;
  title: string;
  body: string;
  bookLabel: string;
  contactLabel: string;
}

export interface ContactCTAProps {
  calendlyHref: string;
  copy: ContactCTACopy;
  contactHref?: string;
}

export function ContactCTA({ calendlyHref, copy, contactHref = '/contact' }: ContactCTAProps) {
  return (
    <Section>
      <Card variant="cta">
        <Rings style={{ opacity: 0.5 }} />
        <div className="cta__inner">
          <Eyebrow>{copy.eyebrow}</Eyebrow>
          <h2>{copy.title}</h2>
          <p>{copy.body}</p>
          <div className="cta__btns">
            <Btn kind="primary" href={calendlyHref} icon="calendar-check" target="_blank">
              {copy.bookLabel}
            </Btn>
            <Btn kind="ghost" href={contactHref} icon="arrow-right">{copy.contactLabel}</Btn>
          </div>
        </div>
      </Card>
    </Section>
  );
}
